module.exports = {
  siteTitle: 'Edlir Velaj | Software Engineer',
  siteDescription:
    'Edlir VElaj is a software engineer based in Tirana, Albania specializing in Frontend (and sometimes Backend) Web Development. He also translates from/to English, Italian and Albanian and teaches Javascript and Excel.',
  siteKeywords:
    'Edlir Velaj, Edlir, Velaj, degun, software engineer, front-end engineer, web developer, javascript, excel, albania, translator, children\'s books',
  siteUrl: 'https://edvelaj.net',
  siteLanguage: 'en_US',

  googleVerification: 'DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpbx9Lk',

  name: 'Edlir Velaj',
  location: 'Tirana, Albania',
  email: 'edlir.velaj@outlook.com',
  github: 'https://github.com/degun/',
  socialMedia: [
    {
      name: 'Github',
      url: 'https://github.com/degun/',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/edlir-velaj-7635b418/',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/edvelaj/',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/edlirv',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '#about',
    },
    {
      name: 'Experience',
      url: '#jobs',
    },
    {
      name: 'Work',
      url: '#projects',
    },
    {
      name: 'Contact',
      url: '#contact',
    },
  ],

  twitterHandle: '@edvelaj',
  googleAnalyticsID: 'UA-45666519-2',

  navHeight: 100,

  greenColor: '#64ffda',
  navyColor: '#0a192f',
  darkNavyColor: '#020c1b',

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
